import React from 'react'
import Svg, { Circle, Path, SvgProps } from 'react-native-svg'

import useTheme from '@common/hooks/useTheme'

const SafePalMiniIcon: React.FC<SvgProps> = ({ width = 32, height = 32, ...styles }) => {
  const { theme } = useTheme()
  return (
    <Svg width={width} height={height} viewBox="0 0 32 32" {...styles}>
      <Circle cx="16" cy="16" r="16" fill={theme.secondaryBackgroundInverted} />
      <Path
        d="M16 6l-9 4.5v5.5c0 5.6 3.9 10.8 9 12 5.1-1.2 9-6.4 9-12v-5.5L16 6zm0 2.2l7 3.5v4.8c0 4.6-3.1 8.8-7 9.9-3.9-1.1-7-5.3-7-9.9v-4.8l7-3.5z"
        fill={theme.primaryBackground}
      />
      <Path
        d="M12.5 15h7v1h-7v-1zm0 2h7v1h-7v-1zm0-4h7v1h-7v-1z"
        fill={theme.primaryBackground}
      />
    </Svg>
  )
}

export default React.memo(SafePalMiniIcon)
